const BOM_VERSIONS = ["v1", "v2"] as const;
const BOM_VERSION_KEY = "bom_ver";

export type BOMVersion = (typeof BOM_VERSIONS)[number];

export default function useBomVersion() {
    const route = useRoute();
    const versionCookie = useCookie<BOMVersion>(BOM_VERSION_KEY, { maxAge: 180 * 24 * 60 * 60 }); // 180 days
    const { gtag } = useGtag();
    const routeBaseName = useRouteBaseName();

    const queryVersion = Array.isArray(route.query[BOM_VERSION_KEY])
        ? route.query[BOM_VERSION_KEY][0]
        : route.query[BOM_VERSION_KEY];

    // update and return the version cookie value, either directly or from query string
    // we need query string support for E2E tests
    function setBOMVersion(version?: BOMVersion) {
        const newVersion = (version ?? queryVersion) as BOMVersion | undefined;

        // make sure it's a valid version string
        if (newVersion && BOM_VERSIONS.includes(newVersion)) {
            versionCookie.value = newVersion;

            let routeName = String(routeBaseName(route));
            if (routeName === "index") routeName = "home";
            else if (routeName === "bom-hash" && route.params.hash === "sample") routeName = "bom-sample";

            gtag("event", `bom_tool_${newVersion}_${routeName}`);
        }

        return newVersion;
    }

    return { bomVersion: versionCookie, setBOMVersion };
}
